export enum FeatureEntitlements {
  RecipePlacements = 'recipe_placements',
  PageBuilderPlacementTargeting = 'page_builder_placement_targeting',
}
